module.exports = require("assert");


/*****************
 ** WEBPACK FOOTER
 ** external "assert"
 ** module id = 26
 ** module chunks = 0
 **/